export const cdnPrefix = (url) => {
  if (url.indexOf('<%=cdnName%>') > -1){
    url = url.replace('<%=cdnName%>', `${window.location.protocol}//${window.location.host.replace('m-', 'm-static-').replace('m.', 'm-static.')}/module_10008/`);
  }
  return url;
};